import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

export interface BadgeSelectDriver extends BaseDriver {
  text: () => string;
  clickAtOption: (index: number) => void;
}
